import { Dispatch } from "react-redux";
import { IApplicationState } from "@nkr/store/index";
import { ISession, ISessionResponse, IUser, ICenter, ICenterMetrics, IProfileResponse } from "@nkr/models/index";
import { AuthActionCreators, IGet, IPost } from "../authorization/index";   //IPost
import { ActionTypes } from "./action-types";
import { IPortalOpo } from "./state";

export const PORTAL_OPO_STORAGE_KEY = 'opo_portal_selected_opo';
import { DisplayType, OrganType } from "@nkr/enums/index";

export interface ICenterResponse {
    data: {
        success: boolean,
        message: string,
        results: ICenter
    }
}

export interface ICenterMetricsResponse {
    data: {
        success: boolean,
        message: string,
        results: ICenterMetrics
    }
}

export interface IArrayResponse<T> {
    data: {
        success: boolean,
        message: string,
        results: T[]
    }
}

export interface IObjectResponse<T> {
    data: {
        success: boolean,
        message: string,
        result: T
    }
}

export const ActionCreators = {
    toggleMenu: () => (dispatch: Dispatch<IApplicationState>) => {
        dispatch({ type: ActionTypes.TOGGLE_MENU });
    },
    toggleLoading: (showLoading?: boolean, message?: string) => (dispatch: Dispatch<IApplicationState>) => {
        dispatch({ type: ActionTypes.TOGGLE_LOADING, message, showLoading })
    },
    toggleLoadingAsync: (showLoading: boolean, message?: string) => (dispatch: Dispatch<IApplicationState>): Promise<void> => {
        dispatch({ type: ActionTypes.TOGGLE_LOADING, message, showLoading });
        return Promise.resolve(null);
    },
    showLoadingAsync: (message: string) => (dispatch: Dispatch<IApplicationState>): Promise<void> => {
        dispatch({ type: ActionTypes.TOGGLE_LOADING, message, showLoading: true });
        return Promise.resolve(null);
    },
    hideLoading: () => (dispatch: Dispatch<IApplicationState>) => {
        dispatch({ type: ActionTypes.TOGGLE_LOADING, message: "", showLoading: false });
    },
    requestUserProfile: () => (dispatch: Dispatch<IApplicationState>): Promise<IUser> => {
        let config: IGet = {
            url: __API__ + "/user/profile"
        };

        return dispatch(AuthActionCreators.apiGet(config)).then((response: IProfileResponse) => {
            if (response.data.success) {
                dispatch(ActionCreators.setUserProfile(response.data.results));
            }

            return Promise.resolve(response.data.results);
        });
    },
    setUserProfile: (user: IUser) => {
        return { type: ActionTypes.SET_USER_PROFILE, user };
    },
    saveSession: (session: ISession) => (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState): Promise<ISessionResponse> => {
        let config: IPost = {
            url: __API__ + "/session",
            data: session
        };

        return dispatch(AuthActionCreators.apiPost(config)).then((response: ISessionResponse) => {
            return Promise.resolve(response);
        });
    },
    showAlert: (title: string, message: string | JSX.Element) => (dispatch: Dispatch<IApplicationState>) => {
        dispatch({
            type: ActionTypes.SHOW_ALERT,
            title,
            message
        });
    },
    hideAlert: () => (dispatch: Dispatch<IApplicationState>) => {
        dispatch({
            type: ActionTypes.HIDE_ALERT
        });
    },
    changeDisplay: (display: DisplayType) => (dispatch: Dispatch<IApplicationState>) => {
        dispatch({ type: ActionTypes.CHANGE_DISPLAY, display });
    },

    getCenter: (centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<ICenterResponse> => {
        let config: IGet = {
            url: __API__ + "/center/" + centerId
        };

        return dispatch(AuthActionCreators.apiGet(config)).then((response: ICenterResponse) => {
            if (response.data.success) {
                dispatch(ActionCreators.setCenter(response.data.results));
            }

            return Promise.resolve(response);
        });
    },
    getBaseCenter: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ICenterResponse> => {
        let config: IGet = {
            url: `${__API__}/center/${centerId}/base`
        };

        const response = await dispatch(AuthActionCreators.apiGet(config));

        return await Promise.resolve(response);
    },
    setCenter: (center: ICenter) => {
        return {
            type: ActionTypes.SET_CENTER,
            center
        };
    },
    getCenterProfile: (centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<ICenterResponse> => {
        let config: IGet = {
            url: __API__ + "/center/" + centerId
        };

        return dispatch(AuthActionCreators.apiGet(config)).then((response: ICenterResponse) => {
            return Promise.resolve(response);
        });
    },
    getCenterMetrics: (centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<ICenterMetricsResponse> => {
        let config: IGet = {
            url: __API__ + "/center/" + centerId + "/metrics"
        };

        return dispatch(AuthActionCreators.apiGet(config)).then((response: ICenterMetricsResponse) => {
            dispatch(ActionCreators.setCenterMetrics(response.data.results));
            return Promise.resolve(response);
        });
    },
    setCenterMetrics: (data: ICenterMetrics) => {
        return {
            type: ActionTypes.SET_CENTER_METRICS,
            data
        }
    },
    setSite: (payload: { domain: string, organ: string, organType: OrganType }) => {
        return {
            type: ActionTypes.SET_SITE,
            payload
        };
    },
    setPortalOpo: (opo: IPortalOpo | null) => (dispatch: Dispatch<IApplicationState>) => {
        if (opo) {
            sessionStorage.setItem(PORTAL_OPO_STORAGE_KEY, JSON.stringify(opo));
        } else {
            sessionStorage.removeItem(PORTAL_OPO_STORAGE_KEY);
        }

        dispatch({ type: ActionTypes.SET_OPO, opo });
    }
};
